var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('app-cities',{on:{"sendCities":_vm.getCities}}),_c('app-regions',{on:{"sendRegions":_vm.getRegions}}),_c('q-btn',{on:{"click":_vm.doSubmit}},[_vm._v("heyy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }